<div class="employee-cat-component-container page-root-container">
    <div class="page-header">
        <div class="page-title">
            <mat-icon class="icon">category</mat-icon><span class="title">Job Position</span>
        </div>
    </div>

    <div class="data-container">
        <app-loader [show]="isLoading"></app-loader>
        <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]" [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)" [hidePageSize]="true">
        </app-search-filter>

        <section tabindex="0" class="table-container">
            <table matSort mat-table [dataSource]="dataSource" (matSortChange)="sortData($event)">
                <ng-container matColumnDef="code">
                    <th mat-sort-header="code" mat-header-cell *matHeaderCellDef>Code</th>
                    <td mat-cell *matCellDef="let item">{{item.code}}</td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-sort-header="name" mat-header-cell *matHeaderCellDef>Name</th>
                    <td mat-cell *matCellDef="let item">{{item.name}}</td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th mat-sort-header="description" mat-header-cell *matHeaderCellDef>Description</th>
                    <td mat-cell *matCellDef="let item">{{item.description}}</td>
                </ng-container>

                <ng-container matColumnDef="hierarchy_order">
                    <th mat-sort-header="hierarchy_order" mat-header-cell *matHeaderCellDef>Hierarchy</th>
                    <td mat-cell *matCellDef="let item">{{item.hierarchy_order}}</td>
                </ng-container>

                <ng-container matColumnDef="is_hq">
                    <th mat-sort-header="is_hq" mat-header-cell *matHeaderCellDef>HQ</th>
                    <td mat-cell *matCellDef="let item">
                        <mat-icon>{{item.is_hq ? 'check_circle' : 'cancel'}}</mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="grade">
                    <th mat-sort-header="grade" mat-header-cell *matHeaderCellDef>Grade</th>
                    <td mat-cell *matCellDef="let item">{{item.grade}}</td>
                </ng-container>

                <ng-container matColumnDef="action" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell class="row-menu-btn" style="width:50px" *matCellDef="let item">
                        <a mat-icon-button class="row-menu-btn" [matMenuTriggerFor]="rowMenu" (click)="onRowSelected(item);$event.stopPropagation();">
                            <mat-icon>more_vert</mat-icon>
                        </a>
                        <mat-menu #rowMenu>
                            @if(permission.can_delete){
                            <button mat-menu-item (click)="onDelete(item)">Delete</button>
                            }
                            @if(permission.can_edit){
                            <button mat-menu-item (click)="onEdit(item)">Edit</button>
                            }@else{
                            <button mat-menu-item (click)="onEdit(item)">View</button>
                            }
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row class="table-element-row" *matRowDef="let item; columns: displayedColumns;" (click)="onRowSelected(item)" (dblclick)="onEdit(item)" [ngClass]="{'row-selected': item.id===selectedItem?.id}"></tr>
            </table>
        </section>

        @if(pagingData.length<=0){
        <div class="no-data-container">
            <img src="assets/images/no-data.png">
            <span class="no-data-info">No data found. Please remove or redefine the filters if any.</span>
        </div>
        }
    </div>
</div>
